export { AnalyticsFormComponent } from './lib/analytics-form/analytics-form.component';
export * from './lib/analytics.module';
